<template>
  <base-modal
    :show-buttons="false"
    @close="close"
  >
    <template #title>
      Aviso
    </template>

    <template #body>
      <div class="content has-text-centered">
        <h3>
          Olá parceiro do Prata Digital.
        </h3>
        <p>
          Abaixo seguem os principais procedimentos de segurança:
        </p>
        <p>
          Análise facial do tomador do crédito - base de dados que
          serve como parâmetro para evidenciar a veracidade da
          proposta.
        </p>
        <p>
          Consulta na RFB - o CPF do tomador é checado na Receita
          Federal a fim de se evitar propostas de CPFs inativos.
        </p>
        <p>
          Geolocalização - o local da formalização do contrato é
          confrontado com a região do endereço informado como
          residência do tomador do crédito.
        </p>
        <p>
          Consulta externa de endereço - serve para ratificar que
          o CPF tomador reside no local ou nas proximidades do
          local onde alega morar.
        </p>

        <hr>

        <button
          class="button is-primary is-medium mx-auto my-3"
          @click="close"
        >
          Entendido
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: 'ModalCreditor',

  components: {
    BaseModal,
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  top: 0;

  padding: .5rem 0 1.5rem ;
  margin-bottom: 1.5rem;
  background-color: #fff;
  border-bottom: 1px solid hsl(0deg, 0%, 96%);
}

.content {
  height: auto;
  max-height: 55vh;
  overflow-y: auto;
}
</style>
